import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "form-group" };
var _hoisted_2 = { class: "switch toggle toggle--m offer-switch" };
var _hoisted_3 = { class: "switch__main" };
var _hoisted_4 = ["disabled"];
var _hoisted_5 = { class: "switch__cover toggle__cover" };
var _hoisted_6 = { class: "switch__label toggle__label" };
import Sprite from "./Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Toggle',
    props: /*@__PURE__*/ _mergeModels({
        label: { type: String, required: true },
        disabled: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup: function (__props) {
        var value = _useModel(__props, "modelValue");
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "switch__input",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((value).value = $event); }),
                            disabled: __props.disabled
                        }, null, 8 /* PROPS */, _hoisted_4), [
                            [_vModelCheckbox, value.value]
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_5, [
                            _createVNode(Sprite, { name: "check" })
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_6, [
                            _renderSlot(_ctx.$slots, "default", {}, function () { return [
                                _createTextVNode(_toDisplayString(__props.label), 1 /* TEXT */)
                            ]; }),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _renderSlot(_ctx.$slots, "suffix")
                        ])
                    ])
                ])
            ]));
        };
    }
});
